import React, { useState, useMemo, useEffect } from "react";
import { Link } from "react-router-dom";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import TableContainer from "../../Components/Common/TableContainer";
import {
  Button,
  Col,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  Label,
  Card,
  CardBody,
  FormGroup,
  Badge,
} from "reactstrap";
import Breadcrumbs from "../../Components/Common/Breadcrumb";
import DeleteModal from "../../Components/Common/DeleteModal";
import { toast, ToastContainer } from "react-toastify";
import { deleteUser, getStudents } from "utils/apiService";
import StudentModal from "./StudentModal";

function StudentList() {
  document.title = "Students List";
  const [students, setStudents] = useState([]);
  const [modal, setModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState([]);

  /* useEffect(() => {
    const fetchStudents = async () => {
      try {
        const data = await getStudents();
        setStudents(data.response);
        console.log("Fetched Students:", data.response);
      } catch (err) {
        console.error("Failed to fetch students:", err);
      }
    };

    fetchStudents();
  }, []);
 */
  useEffect(() => {
    fetchStudents();
  }, []);

  const handleWhatsApp = (phoneNumber: string) => {
    if (phoneNumber) {
      const formattedNumber = phoneNumber.replace(/\D/g, "");
      window.open(`https://wa.me/${formattedNumber}`, "_blank");
    } else {
      alert("Phone number not available");
    }
  };

  const fetchStudents = async () => {
    try {
      const data = await getStudents();
      setStudents(data.response);
      console.log("Fetched Students:", data.response);

      const phones = data.response.map((student) => student.phone_number);
      setPhoneNumber(phones);
      console.log("Extracted Phone Numbers:", phones);
    } catch (err) {
      console.error("Failed to fetch students:", err);
    }
  };

  const toggle = () => setModal(!modal);

  const handleEdit = (student: any) => {
    setSelectedStudent(student);
    setIsEdit(true);
    setModal(true);
    console.log("Edit button pressed!", student);
  };

  const handleDelete = async (student: any) => {
    setSelectedStudent(student);
    setDeleteModal(true);
  };
  const confirmDelete = async () => {
    try {
      if (selectedStudent) {
        await deleteUser((selectedStudent as { user_id: number }).user_id);
        toast.success("Student deleted successfully!");
        fetchStudents();
      }
    } catch (error) {
      toast.error("Failed to delete student.");
      console.error("Delete Error:", error);
    } finally {
      setDeleteModal(false);
      setSelectedStudent(null);
    }
  };

  const handleAdd = () => {
    setSelectedStudent(null);
    setIsEdit(false);
    setModal(true);
  };

  const columns = useMemo(
    () => [
      {
        header: "Sr No.",
        cell: (cellProps) => {
          // Adding 1 because array index starts from 0
          return cellProps.row.index + 1;
        },
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Name",
        accessorKey: "user_name",
        cell: (cellProps) => (
          <Link to="#" className="text-body fw-bold">
            {cellProps.row.original.user_name}
          </Link>
        ),
      },
      {
        header: "Email",
        accessorKey: "user_email",
      },
      {
        header: "Phone",
        accessorKey: "phone_number",
        cell: ({ row }) => {
          const phone = row.original.phone_number || "";
          const countryCode = row.original.country_code;

          return countryCode ? `+${countryCode}  ${phone}` : phone;
        },
      },
      {
        header: "Address",
        accessorKey: "address",
      },
      {
        header: "Actions",
        accessorKey: "actions",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cellProps) => {
          const student = cellProps.row.original;
          return (
            <div className="d-flex gap-3">
              <Link
                to="#"
                className="text-success"
                onClick={() => handleEdit(student)}
              >
                <i className="mdi mdi-pencil font-size-18" />
              </Link>
              <Link
                to="#"
                className="text-success"
                onClick={() => handleWhatsApp(student.phone_number)}
              >
                <i className="mdi mdi-whatsapp font-size-18" />
              </Link>
              <Link
                to="#"
                className="text-danger"
                onClick={() => handleDelete(student)}
              >
                <i className="mdi mdi-delete font-size-18" />
              </Link>
            </div>
          );
        },
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={confirmDelete}
        onCloseClick={() => setDeleteModal(false)}
        message="Are you sure you want to delete this student ? You won't be able to revert this!"
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs breadcrumbItem="Students List" />
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={students}
                    isGlobalFilter={false}
                    isAddButton={true}
                    customPageSize={10}
                    handleUserClick={handleAdd}
                    isPagination={true}
                    buttonClass="btn btn-success btn-rounded waves-effect waves-light mb-2 me-2"
                    buttonName=" Add New Student"
                    tableClass="align-middle table-nowrap dt-responsive nowrap w-100"
                    theadClass="table-light"
                    pagination="pagination"
                    paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
      <StudentModal
        isOpen={modal}
        toggle={() => setModal(false)}
        student={selectedStudent}
        isEdit={isEdit}
        refreshData={fetchStudents}
      />
      <ToastContainer />
    </React.Fragment>
  );
}

export default StudentList;
